import React from 'react';
import Header from './Header';
import Footer from './Footer';

interface MainContainerProps {
  children: React.ReactNode;
  className?: string;
}

const MainContainer: React.FC<MainContainerProps> = ({ children, className }) => {
  return (
    <div className="flex flex-col min-h-screen h-full">
      <Header />
      <main className={`flex-grow w-full max-w-[1200px] self-center px-6 ${className}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default MainContainer;
